import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { MenuOpen, Menu as MenuIcon } from "@mui/icons-material";
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarMobileMenu,
} from "./styles";
import {
  useMaterialUIController,
  setMiniSidenav,
} from "../../../helpers/context";
import Box from "@mui/material/Box";
import CommitButton from "../../../routes/commit/components/commitButton";
import ProfileButton from "./components/profileButton";
import CheckConnection from "./components/checkConnection";
import api from "../../../helpers/api/Api";
import ApiUrls from "../../../helpers/urls/ApiUrls";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

function DashboardNavbar({ light, isMini }) {
  const use_dispatch = useDispatch();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, darkMode } = controller;

  const userType = JSON.parse(localStorage.getItem("user"))?.type;

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (!light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  useEffect(() => {
    getRefreshRate();
  }, []);

  const getRefreshRate = () => {
    const formData = new FormData();
    formData.append("param", "refreshrate");

    api.post(ApiUrls.params.get, formData)
      .then((response) => {
        use_dispatch({
          type: "SET_REFRESH_RATE",
          payload: response.data.value
        });
      })
      .catch((error) => {
      });
  }

  return (
    <AppBar
      position={"static"}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar: true, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)} disableGutters>
        {isMini ? null : (
          <Box sx={(theme) => navbarRow(theme, { isMini })}>

            <Box color={light ? "white" : "inherit"} className="navbar-mini">
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                {miniSidenav ? <MenuOpen sx={iconsStyle} /> : <MenuIcon sx={iconsStyle} />}
              </IconButton>

              {userType == 0 ? <CheckConnection /> : null}
              <CommitButton />
            </Box>
          </Box>
        )}
        <ProfileButton />
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.defaultProps = {
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};
export default DashboardNavbar;
